"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
exports.mergeProps = mergeProps;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactRedux = require("react-redux");
var _selectors = require("./selectors");
var _ConfirmationSmsCodeFormController = require("../../../../components/ConfirmationSmsCodeFormController");
var _tracking = require("../../../../utils/tracking");
var _authentication = require("../../../../actions/authentication");
var _twoFactorPhone = require("../../../../actions/twoFactorPhone");
var _source = require("../../../../selectors/source");
const _excluded = ["verifyValidationCode"],
  _excluded2 = ["phone"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapStateToProps(state) {
  return {
    phone: (0, _selectors.phoneSelector)(state),
    sendValidationCodeStatus: (0, _selectors.sendValidationCodeStatusSelector)(state),
    isSubmitting: (0, _selectors.isSubmittingSelector)(state),
    hasCodeError: (0, _selectors.hasAuthErrorSelector)(state),
    codeError: (0, _selectors.authErrorSelector)(state),
    resendTimeout: (0, _selectors.resendTimeoutSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    verifyValidationCode(code, phone) {
      dispatch((0, _authentication.authenticate)({
        code,
        phone
      }));
    },
    sendValidationCode() {
      dispatch((0, _twoFactorPhone.sendCodeMultichannel)());
    },
    onResendClick(source) {
      (0, _tracking.trackPhoneAuthResendValidationCode)(source);
    }
  };
}
function mergeProps(stateProps, dispatchProps) {
  const {
      verifyValidationCode
    } = dispatchProps,
    restDispatchProps = (0, _objectWithoutProperties2.default)(dispatchProps, _excluded);
  const {
      phone
    } = stateProps,
    restStateProps = (0, _objectWithoutProperties2.default)(stateProps, _excluded2);
  return _objectSpread(_objectSpread(_objectSpread({}, restStateProps), restDispatchProps), {}, {
    verifyValidationCode(code) {
      verifyValidationCode(code, phone);
    }
  });
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_ConfirmationSmsCodeFormController.ConfirmationSmsCodeFormController);